var _path, _path2, _line;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAkarIconsMobileDevice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.3333 2.41669H9.66667C8.33198 2.41669 7.25 3.49867 7.25 4.83335V24.1667C7.25 25.5014 8.33198 26.5834 9.66667 26.5834H19.3333C20.668 26.5834 21.75 25.5014 21.75 24.1667V4.83335C21.75 3.49867 20.668 2.41669 19.3333 2.41669Z",
    className: "svgStroke",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 2H18C18 3.10457 17.1046 4 16 4H13C11.8954 4 11 3.10457 11 2Z",
    className: "svgFill"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 10.5,
    y1: 25,
    x2: 18.5,
    y2: 25,
    className: "svgStroke",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAkarIconsMobileDevice);
export default __webpack_public_path__ + "static/media/akar-icons_mobile-device.edc84f10.svg";
export { ForwardRef as ReactComponent };